import React from 'react';
import LoadingSpinnerWithoutOverlay from './LoadingSpinnerWithoutOverlay';

type ListUtilityLoadingSpinnerProps = {
  loading: boolean;
  LoadingComponent?: JSX.Element;
};
const ListUtilityLoadingSpinner: React.FC<ListUtilityLoadingSpinnerProps> = ({
  loading,
  LoadingComponent
}) => {
  if (!loading) return null;

  return LoadingComponent ? (
    LoadingComponent
  ) : (
    <div>
      <LoadingSpinnerWithoutOverlay xOffset={20} yOffset={50} size={5} />
    </div>
  );
};
export default ListUtilityLoadingSpinner;
